import React, { forwardRef, useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';
import { consoleApi } from '../../../api';
import { RECAPTCHA_SKIP } from '../../../utils/appConfig';

const CaptchaWrapper = forwardRef(({ handleChange, ...attrs }, ref) => {
  const [recaptchaKey, setRecaptchaKey] = useState('');

  const getKey = async () => {
    try {
      const response = await consoleApi.getRecaptchaKey();
      setRecaptchaKey(response.recaptcha_key);
    } catch (error) {
      throw error;
    }
  };
  // The empty dependency array means this useEffect will only run once, when the component mounts
  useEffect(() => {
    getKey();
  }, []);

  return !RECAPTCHA_SKIP && recaptchaKey ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ReCAPTCHA ref={ref} sitekey={recaptchaKey} onChange={handleChange} {...attrs} />
  ) : null;
});

CaptchaWrapper.propTypes = {
  // eslint-disable-next-line react/require-default-props
  forwardRef: PropTypes.shape({
    /**
     * The onChange event.
     */
    handleChange: PropTypes.func.isRequired,
  }),
};

export default CaptchaWrapper;
